import { ExternalLink } from "lucide-react";
import { PublicLayout } from "@/components/layout/public-layout";
import { PublicPageHeader } from "@/components/layout/public-page-header";
import { Photo, type PhotoName } from "@/components/ui/photo";
import { PHOTOS } from "@/lib/photos.gen";

const NAMES = (Object.keys(PHOTOS) as PhotoName[]).filter((name, index, names) =>
  names.findIndex((other) => PHOTOS[other].asset === PHOTOS[name].asset) === index,
);

/** Who made each image and the terms it is used under (CC BY needs this shown). */
export function CreditsPage() {
  return (
    <PublicLayout>
      <PublicPageHeader
        crumb="CREDITS"
        label="画像の出典"
        title="画像の出典"
        lead="このサービスで使っている画像の一覧です。このサービスのために作った画像には、その旨を記しています。外部から入手した画像には、作者と使ってよい条件を記しています。"
        photo="feature-knowledge-notes"
      />
      <div className="section-padding mx-auto max-w-[1440px] px-4 sm:px-8">
        <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {NAMES.map((name) => {
            const { alt, credit } = PHOTOS[name];
            return (
              <li key={name} className="ui-section ui-section-link overflow-hidden ">
                <div className="relative aspect-[4/3]">
                  <Photo name={name} fill sizes="(min-width: 1024px) 360px, (min-width: 640px) 50vw, 100vw" decorative />
                </div>
                <div className="space-y-1.5 px-4 py-3 text-[13px]">
                  <p className="text-ink">{alt}</p>
                  <p className="text-muted">作者：{credit.author}</p>
                  {/* The service's own images have no outside source or licence page. */}
                  {credit.source ? (
                  <p className="flex flex-wrap gap-x-4 gap-y-1">
                    <a href={credit.licenseUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-brand hover:underline">
                      {credit.license}
                      <ExternalLink className="size-3.5" />
                    </a>
                    <a href={credit.source} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-brand hover:underline">
                      入手元（{new URL(credit.source).hostname}）
                      <ExternalLink className="size-3.5" />
                    </a>
                  </p>
                  ) : (
                    <p className="text-muted">{credit.license}</p>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </PublicLayout>
  );
}
